export function userEligibility() {
  if (applicationData?.descriptionOfLand?.landUsesType === "Residential") {
    if (applicationData?.descriptionOfLand?.subLandUseAsPerLayout === "Group Housing") {
      if (applicationData?.descriptionOfLand?.landArea >= 2000) {
        return true;
      }
    }
  } else if (!(applicationData?.descriptionOfLand?.landUsesType === "Residential")) {
    if (applicationData?.descriptionOfLand?.landArea >= 2500) {
      return true;
    }
  } else return false;
}

export function validateChecklist(data) {
  console.log("checklistValidation", data);

  const buildingHeight = Number(data?.checklist?.firstCheckList?.buildingHeight);
  const requiredParking = Number(data?.checklist?.firstCheckList?.totalParkingRequired);
  const proposedParking = Number(data?.checklist?.firstCheckList?.totalParkingProposed);
  const stiltCars = Number(data?.checklist?.firstCheckList?.parkingProvision?.inStiltArea?.cars);
  const openAreaCars = Number(data?.checklist?.firstCheckList?.parkingProvision?.openArea?.cars);
  const basementCars = Number(data?.checklist?.firstCheckList?.parkingProvision?.inBasement?.cars);
  const { front, rear, ssb1, ssb2 } = data?.checklist?.firstCheckList?.setbackPosition;

  // Ensure setbacks are also treated as numbers
  const frontNum = Number(front);
  const rearNum = Number(rear);
  const ssb1Num = Number(ssb1);
  const ssb2Num = Number(ssb2);
  console.log(
    "dataFronValidation",
    stiltCars + basementCars + openAreaCars !== proposedParking,
    proposedParking < requiredParking,
    proposedParking,
    requiredParking,
    stiltCars + basementCars + openAreaCars
  );

  const setbackRanges = [
    { maxHeight: 15, minSetback: 5 },
    { maxHeight: 18, minSetback: 6 },
    { maxHeight: 21, minSetback: 7 },
    { maxHeight: 24, minSetback: 8 },
    { maxHeight: 27, minSetback: 9 },
    { maxHeight: 30, minSetback: 10 },
    { maxHeight: 35, minSetback: 11 },
    { maxHeight: 40, minSetback: 12 },
    { maxHeight: 45, minSetback: 13 },
    { maxHeight: 50, minSetback: 14 },
    { maxHeight: 55, minSetback: 15 },
    { maxHeight: Infinity, minSetback: 16 },
  ];

  // Find the appropriate setback requirement based on the building height
  const applicableRange = setbackRanges.find((range) => buildingHeight <= range.maxHeight);

  // If no range is found, return an error or handle as needed
  if (!applicableRange) {
    return { message: "Invalid building height.", isChecklistValid: false };
  }

  const { minSetback } = applicableRange;
  const setbacks = [frontNum, rearNum, ssb1Num, ssb2Num];
  // Check if all setbacks meet the minimum required value
  for (let i = 0; i < setbacks.length; i++) {
    if (setbacks[i] < minSetback) {
      return {
        message: `For a building height of up to ${applicableRange.maxHeight} meters, the minimum setback for all sides should be at least ${minSetback} meters. Please ensure that the front, rear, and side setbacks are properly adjusted.`,
        isChecklistValid: false,
      };
    }
  }
  if (proposedParking < requiredParking) {
    return {
      message: "The proposed parking capacity is less than the required parking. Please adjust the proposed value to meet the requirements.",
      isChecklistValid: false,
    };
  }
  if (stiltCars + basementCars + openAreaCars !== proposedParking) {
    return {
      message:
        "The total number of cars in the stilt, basement, and open areas does not match the proposed parking capacity. Please adjust the values to meet the required total.",
      isChecklistValid: false,
    };
  }

  // If all setbacks are valid
  console.log("Validation successful!");
  return { message: "", isChecklistValid: true };
}

export const fetchLandUseApplication = async (applicationNum) => {
  console.log("loggingParamsFromAsync", applicationNum);

  try {
    sessionStorage.setItem("LandUseAppNum", applicationNum);
    // Simulate the data fetch (Replace with actual API call)
    const response = await Digit.OBPSService.BPAFastPASSearch({ land_Id: applicationNum });
    console.log("loggingParamsFromAsync", applicationNum, response);

    if (response?.BPA?.length > 0) {
      console.log("loggingFromQueyrFunc", response.BPA[0]);

      return response.BPA.filter((item) => item.applicationType === "FORM_LANDUSE")[0]; // Return the application data
    } else {
      throw new Error("No data found.");
    }
  } catch (error) {
    throw error; // Throw error for handling in the React Query hook
  }
};
